export default "__VITE_ASSET__DQCnlsc6__"